import { ThreeView } from "../View3dWebCad";
import * as THREE from 'three';
import * as marietta from '../../../../marietta';
import { SceneExtras } from "../sceneExtras";
import { command } from "./command";
import { ObjectType } from '../ObjectType';


export class DeleteObject extends command {

    constructor(private object: THREE.Object3D) {
        super();
    }

    public execute() {
        if (this.object == null) return;

        ThreeView.get().ItemDragManager.resetController();          // コントローラーの削除
        ThreeView.get().pickermanager.removePicker();               // pickerの削除

        ThreeView.get().wcItemmgr.removefurnitureObject(this.object);

        const uuid: string = this.object.userData.modelInfo && this.object.userData.modelInfo.uuid;
        marietta.webcad.WebCADGlobal.itemManager.delete2Ditem(uuid);    // 2D部品削除通知

        if (ObjectType.isPin(this.object)) return;
        new SceneExtras(ThreeView.get().wcItemmgr.GltfExtras, this.object).deleate();
    }
}
